import { ServerConfig } from "@/config/config";
import { createSocketService } from "@/utils/services/socket-service-factory";

export const EVENT_SWITCH_SESSION = "/session-switch";

export const MainSocketService = createSocketService(ServerConfig.socket, "/socket.io/client/");